function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.3973 3.57813L17.3482 1.58594C17.0268 1.27344 16.4241 1 15.9821 1H9.07143C7.98661 1 7.14286 1.85938 7.14286 2.875V4.75H3.92857C2.84375 4.75 2 5.60938 2 6.625V19.125C2 20.1797 2.84375 21 3.92857 21H12.9286C13.9732 21 14.8571 20.1797 14.8571 19.125V17.25H18.0714C19.1161 17.25 20 16.4297 20 15.375V4.90625C20 4.47656 19.7188 3.89063 19.3973 3.57813ZM12.6875 19.125H4.16964C4.00893 19.125 3.92857 19.0469 3.92857 18.8906V6.85938C3.92857 6.74219 4.00893 6.625 4.16964 6.625H7.14286V15.375C7.14286 16.4297 7.98661 17.25 9.07143 17.25H12.9286V18.8906C12.9286 19.0469 12.808 19.125 12.6875 19.125ZM17.8304 15.375H9.3125C9.15179 15.375 9.07143 15.2969 9.07143 15.1406V3.10938C9.07143 2.99219 9.15179 2.875 9.3125 2.875H13.5714V6.3125C13.5714 6.85938 13.9732 7.25 14.5357 7.25H18.0714V15.1406C18.0714 15.2969 17.9509 15.375 17.8304 15.375ZM18.0714 5.375H15.5V2.875H15.8616C15.942 2.875 15.9821 2.91406 16.0223 2.95313L17.9911 4.86719C18.0313 4.90625 18.0714 4.94531 18.0714 5.02344V5.375Z"
});

var SvgCopy = function SvgCopy(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22",
      fill: "none"
    }, props), _ref)
  );
};

export default SvgCopy;